import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";

import { Row, Col, Form, InputGroup, Modal, Container } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import { VehicleCategory } from "../../../../utils/apis/masters/masters";
import { Context } from "../../../../utils/context";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
library.add(fas);
const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [vehicleCategort, setVehicleCategory] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();

      DataToSend.append("name", data?.name);
      DataToSend.append("image", data?.image[0]);
      const response = await postData(`/masters/save-as`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 100;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add User Help Type</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add Save As </Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                            className="blogfeedclass"
                          >
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="name"
                                              placeholder="Name"
                                              className={classNames("", {
                                                "is-invalid": errors?.name,
                                              })}
                                              {...register("name", {
                                                required: "Name is required",
                                                maxLength: {
                                                  value: maxCharLimit,
                                                  message: `Name cannot exceed ${maxCharLimit} characters`,
                                                },
                                              })}
                                              maxLength={maxCharLimit}
                                              onChange={handleInputChange}
                                            />
                                          </InputGroup>
                                          <div className="text-end">
                                            <small>
                                              {maxCharLimit} characters Limit{" "}
                                            </small>
                                          </div>

                                          {errors.name && (
                                            <span className="text-danger">
                                              {errors.name.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Col md={6}>
                                  <div className="main-form-section mt-3">
                                    <Form.Group>
                                      <div className="text-center">
                                        <Form.Label>Image</Form.Label>
                                      </div>
                                      <InputGroup>
                                        <Form.Control
                                          type="file"
                                          name="image"
                                          placeholder="Image"
                                          className={classNames("", {
                                            "is-invalid": errors?.image,
                                          })}
                                          {...register("image", {
                                            required: "Image is required",
                                          })}
                                          accept="image/*"
                                          onChange={handleImageChange}
                                        />
                                      </InputGroup>
                                      {errors.image && (
                                        <span className="text-danger">
                                          {errors.image.message}
                                        </span>
                                      )}
                                    </Form.Group>
                                    {imagePreview && (
                                      <div className="mt-2">
                                        <img
                                          src={imagePreview}
                                          alt="Category Preview"
                                          style={{ maxWidth: "100px" }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Col>

                                {/* New field for uploading an image */}

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit(onSubmit)}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
